
import { defineComponent } from 'vue';

import SocialMediaIconBox from '../../../components/Frontend/SocialMediaIconBox.vue';
import Footer from '../../../components/Frontend/Footer.vue';
import { mdiChevronUp } from '@mdi/js';

export default defineComponent({
  meta: {
    de: {
      title: 'Wo wir sind | Styria Media Group',
      keywords: ['standorte', 'graz', 'adresse', 'graz', 'styria', 'international', 'headquatrter', 'kroatien', 'slowenien'],
      description: 'Graz, Wien, Zagreb, Ljubljana, Klagenfurt: Österreich, Kroatien und Slowenien sind der Kernmarkt der Styria Media Group.',
      image: require('@/assets/img/og/ueber-uns.png'),
    },
    en: {
      title: 'Where we are | Styria Media Group',
      keywords: ['location', 'graz', 'address', 'graz', 'styria', 'international', 'headquatrter', 'croatia', 'slovenia'],
      description: 'Graz, Vienna, Zagreb, Ljubljana, Klagenfurt: Austria, Croatia and Slovenia are the core market of the Styria Media Group.',
      image: require('@/assets/img/og/ueber-uns.png'),
    },
  },
  components: {
    SocialMediaIconBox,
    Footer,
  },
  setup() {
    return {
      mdiChevronUp,
    };
  },
});
